// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */
/* SAM (Smart Analyst for Markets) — Analysis Panel Styles */

.analysis-panel {
  height: 100%;
  overflow-y: auto;
  padding: 12px;
  background: var(--bg);
  color: var(--text);
}

.analysis-header {
  margin-bottom: 12px;
}

.analysis-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.analysis-title-row h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.analysis-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
  font-size: 11px;
  color: var(--text-dim);
}

.analysis-refresh {
  padding: 3px 10px;
  font-size: 11px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.analysis-refresh:hover { opacity: 0.85; }
.analysis-refresh:disabled { opacity: 0.5; cursor: not-allowed; }

.analysis-time {
  font-size: 10px;
  color: var(--text-dim);
}

.analysis-loading, .analysis-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  color: var(--text-dim);
  font-size: 13px;
}

/* ─── Signal Badge ───────────────────────────────────────────── */
.signal-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.signal-sm { padding: 1px 6px; font-size: 10px; }
.signal-bullish { background: rgba(34, 197, 94, 0.15); color: #22c55e; }
.signal-bearish { background: rgba(239, 68, 68, 0.15); color: #ef4444; }
.signal-mixed { background: rgba(234, 179, 8, 0.15); color: #eab308; }
.signal-neutral { background: rgba(100, 116, 139, 0.15); color: #94a3b8; }

/* ─── Severity Dot ───────────────────────────────────────────── */
.sev-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sev-high { background: #ef4444; box-shadow: 0 0 4px #ef4444; }
.sev-med { background: #eab308; }
.sev-low { background: #64748b; }

/* ─── Alerts ─────────────────────────────────────────────────── */
.alerts-section {
  margin-bottom: 14px;
}
.alerts-section h3 {
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 6px 0;
  color: var(--text);
}
.alerts-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.alert-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: var(--card);
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: background 0.15s;
}
.alert-item:hover { background: var(--border); }
.alert-high { border-left-color: #ef4444; }
.alert-medium { border-left-color: #eab308; }
.alert-low { border-left-color: #64748b; }

.alert-sym {
  font-weight: 700;
  color: var(--accent);
  min-width: 45px;
}
.alert-msg {
  color: var(--text);
  flex: 1 1;
}

/* ─── Score Chart ─────────────────────────────────────────────── */
.score-chart-section {
  margin-bottom: 14px;
}
.score-chart-section h3 {
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

/* ─── Holdings Grid ──────────────────────────────────────────── */
.holdings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
}

.holding-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: border-color 0.15s, transform 0.1s;
}
.holding-card:hover {
  border-color: var(--accent);
  transform: translateY(-1px);
}
.holding-error { opacity: 0.5; cursor: default; }

.hcard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.hcard-symbol {
  font-weight: 700;
  font-size: 15px;
  color: var(--text);
}
.hcard-price {
  font-size: 18px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 4px;
}
.hcard-trend {
  margin-bottom: 8px;
}
.hcard-trend-label {
  font-size: 11px;
  font-weight: 600;
}
.hcard-error {
  font-size: 11px;
  color: var(--text-dim);
}

/* ─── S/R Bar (Mini visual) ──────────────────────────────────── */
.sr-bar-wrap {
  margin: 8px 0;
}
.sr-bar {
  position: relative;
  height: 6px;
  background: var(--border);
  border-radius: 3px;
  margin-bottom: 4px;
}
.sr-level {
  position: absolute;
  top: -3px;
  transform: translateX(-50%);
}
.sr-level-line {
  display: block;
  width: 2px;
  height: 12px;
  border-radius: 1px;
}
.sr-level.support .sr-level-line { background: #22c55e; }
.sr-level.resistance .sr-level-line { background: #ef4444; }

.sr-current {
  position: absolute;
  top: -4px;
  transform: translateX(-50%);
}
.sr-current-dot {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent);
  border: 2px solid var(--bg);
  box-shadow: 0 0 4px var(--accent);
}

.sr-labels {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: var(--text-dim);
}
.sr-current-label {
  font-weight: 700;
  color: var(--accent);
}

/* ─── Holding Card Stats ─────────────────────────────────────── */
.hcard-stats {
  display: flex;
  gap: 8px;
  margin-top: 6px;
}
.hcard-stat {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.hcard-stat-label {
  font-size: 9px;
  color: var(--text-dim);
  text-transform: uppercase;
}
.hcard-stat-value {
  font-size: 13px;
  font-weight: 600;
}

.hcard-breakout {
  margin-top: 6px;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.5px;
}
.hcard-breakout.bullish { background: rgba(34, 197, 94, 0.15); color: #22c55e; }
.hcard-breakout.bearish { background: rgba(239, 68, 68, 0.15); color: #ef4444; }

.hcard-patterns {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}
.hcard-pattern {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
  background: var(--border);
  color: var(--text);
}
.hcard-pattern.bullish { color: #22c55e; }
.hcard-pattern.bearish { color: #ef4444; }

.hcard-footer {
  margin-top: 8px;
  font-size: 10px;
  color: var(--text-dim);
  text-align: center;
}

/* ─── Detail Modal ───────────────────────────────────────────── */
.analysis-modal {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  width: 90%;
  max-width: 650px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 20px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}

.amodal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.amodal-header h2 {
  margin: 0;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.amodal-close {
  background: none;
  border: none;
  color: var(--text-dim);
  font-size: 24px;
  cursor: pointer;
}
.amodal-close:hover { color: var(--text); }

.amodal-section {
  margin-bottom: 18px;
  padding: 12px;
  background: var(--card);
  border-radius: 8px;
  border: 1px solid var(--border);
}
.amodal-section h3 {
  font-size: 13px;
  font-weight: 700;
  margin: 0 0 10px 0;
  color: var(--text);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.amodal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
  margin-bottom: 8px;
}
.amodal-stat {
  display: flex;
  flex-direction: column;
}
.amodal-label {
  font-size: 10px;
  color: var(--text-dim);
  text-transform: uppercase;
}
.amodal-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.amodal-ma-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.ma-pill {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
}
.ma-above { background: rgba(34, 197, 94, 0.12); color: #22c55e; }
.ma-below { background: rgba(239, 68, 68, 0.12); color: #ef4444; }

.amodal-signals {
  margin-top: 8px;
}
.amodal-signal-item {
  font-size: 12px;
  padding: 4px 8px;
  margin-bottom: 4px;
  background: rgba(59, 130, 246, 0.1);
  border-left: 3px solid var(--accent);
  border-radius: 0 4px 4px 0;
  color: var(--text);
}

/* ─── S/R Detail Table ───────────────────────────────────────── */
.sr-table {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 10px;
}
.sr-col h4 {
  font-size: 12px;
  margin: 0 0 6px 0;
  font-weight: 600;
}
.sr-row {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  border-bottom: 1px solid var(--border);
}
.sr-price {
  font-weight: 700;
  font-size: 13px;
}
.sr-meta {
  font-size: 10px;
  color: var(--text-dim);
}
.sr-dist {
  font-size: 10px;
  color: var(--text-dim);
}

/* ─── Breakout Banner ────────────────────────────────────────── */
.breakout-banner {
  padding: 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
}
.breakout-banner.bullish { background: rgba(34, 197, 94, 0.1); border: 1px solid rgba(34, 197, 94, 0.3); color: #22c55e; }
.breakout-banner.bearish { background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); color: #ef4444; }
.breakout-dir { font-weight: 700; font-size: 14px; }

/* ─── Pattern Cards ──────────────────────────────────────────── */
.pattern-card {
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 6px;
  border-left: 3px solid;
}
.pattern-bullish { background: rgba(34, 197, 94, 0.06); border-left-color: #22c55e; }
.pattern-bearish { background: rgba(239, 68, 68, 0.06); border-left-color: #ef4444; }
.pattern-name { font-weight: 700; font-size: 13px; color: var(--text); }
.pattern-desc { font-size: 11px; color: var(--text-dim); margin-top: 2px; }
.pattern-target { font-size: 11px; font-weight: 600; margin-top: 2px; color: var(--accent); }

/* ─── Candlestick List ───────────────────────────────────────── */
.candle-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.candle-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  border-left: 3px solid transparent;
}
.candle-bull { border-left-color: #22c55e; background: rgba(34, 197, 94, 0.04); }
.candle-bear { border-left-color: #ef4444; background: rgba(239, 68, 68, 0.04); }
.candle-neutral { border-left-color: #64748b; }
.candle-date { color: var(--text-dim); min-width: 75px; font-size: 11px; }
.candle-name { flex: 1 1; font-weight: 600; color: var(--text); }
.candle-signal { font-size: 10px; text-transform: uppercase; font-weight: 600; }
.candle-signal.bullish { color: #22c55e; }
.candle-signal.bearish { color: #ef4444; }
.candle-signal.neutral { color: #64748b; }
.candle-str { font-size: 10px; color: var(--text-dim); }

/* ─── Color Helpers ──────────────────────────────────────────── */
.green { color: #22c55e !important; }
.red { color: #ef4444 !important; }

/* ─── Modal Overlay (reuse from Portfolio) ────────────────────── */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

/* ─── Mobile ─────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .analysis-panel { padding: 8px; }
  .holdings-grid { grid-template-columns: 1fr; }
  .analysis-modal { width: 95%; padding: 14px; }
  .amodal-grid { grid-template-columns: repeat(2, 1fr); }
  .sr-table { grid-template-columns: 1fr; }
  .amodal-ma-row { flex-direction: column; }
}
`, "",{"version":3,"sources":["webpack://./src/Analysis.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF,4DAA4D;;AAE5D;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA,0BAA0B,aAAa,EAAE;AACzC,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA,aAAa,gBAAgB,EAAE,eAAe,EAAE;AAChD,kBAAkB,mCAAmC,EAAE,cAAc,EAAE;AACvE,kBAAkB,mCAAmC,EAAE,cAAc,EAAE;AACvE,gBAAgB,mCAAmC,EAAE,cAAc,EAAE;AACrE,kBAAkB,qCAAqC,EAAE,cAAc,EAAE;;AAEzE,mEAAmE;AACnE;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA,YAAY,mBAAmB,EAAE,2BAA2B,EAAE;AAC9D,WAAW,mBAAmB,EAAE;AAChC,WAAW,mBAAmB,EAAE;;AAEhC,mEAAmE;AACnE;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,4BAA4B;AAC9B;AACA,oBAAoB,yBAAyB,EAAE;AAC/C,cAAc,0BAA0B,EAAE;AAC1C,gBAAgB,0BAA0B,EAAE;AAC5C,aAAa,0BAA0B,EAAE;;AAEzC;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA,iBAAiB,YAAY,EAAE,eAAe,EAAE;;AAEhD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA,mCAAmC,mBAAmB,EAAE;AACxD,sCAAsC,mBAAmB,EAAE;;AAE3D;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA,sBAAsB,kBAAkB,EAAE;;AAE1C;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,YAAY,mCAAmC,EAAE,cAAc,EAAE;AACjE,YAAY,mCAAmC,EAAE,cAAc,EAAE;;AAEjE;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA,2BAA2B,kCAAkC,EAAE,wCAAwC,EAAE,cAAc,EAAE;AACzH,2BAA2B,kCAAkC,EAAE,wCAAwC,EAAE,cAAc,EAAE;AACzH,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;;AAEnD,mEAAmE;AACnE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA,mBAAmB,mCAAmC,EAAE,0BAA0B,EAAE;AACpF,mBAAmB,mCAAmC,EAAE,0BAA0B,EAAE;AACpF,gBAAgB,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACvE,gBAAgB,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;AAC1E,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB,EAAE;;AAE5F,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;AACA,eAAe,0BAA0B,EAAE,mCAAmC,EAAE;AAChF,eAAe,0BAA0B,EAAE,mCAAmC,EAAE;AAChF,kBAAkB,0BAA0B,EAAE;AAC9C,eAAe,sBAAsB,EAAE,eAAe,EAAE,eAAe,EAAE;AACzE,eAAe,SAAO,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9D,iBAAiB,eAAe,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AAC/E,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,cAAc,eAAe,EAAE,sBAAsB,EAAE;;AAEvD,mEAAmE;AACnE,SAAS,yBAAyB,EAAE;AACpC,OAAO,yBAAyB,EAAE;;AAElC,oEAAoE;AACpE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE;EACE,kBAAkB,YAAY,EAAE;EAChC,iBAAiB,0BAA0B,EAAE;EAC7C,kBAAkB,UAAU,EAAE,aAAa,EAAE;EAC7C,eAAe,qCAAqC,EAAE;EACtD,YAAY,0BAA0B,EAAE;EACxC,iBAAiB,sBAAsB,EAAE;AAC3C","sourcesContent":["/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */\n/* SAM (Smart Analyst for Markets) — Analysis Panel Styles */\n\n.analysis-panel {\n  height: 100%;\n  overflow-y: auto;\n  padding: 12px;\n  background: var(--bg);\n  color: var(--text);\n}\n\n.analysis-header {\n  margin-bottom: 12px;\n}\n\n.analysis-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.analysis-title-row h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.analysis-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 6px;\n  font-size: 11px;\n  color: var(--text-dim);\n}\n\n.analysis-refresh {\n  padding: 3px 10px;\n  font-size: 11px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.analysis-refresh:hover { opacity: 0.85; }\n.analysis-refresh:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.analysis-time {\n  font-size: 10px;\n  color: var(--text-dim);\n}\n\n.analysis-loading, .analysis-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 120px;\n  color: var(--text-dim);\n  font-size: 13px;\n}\n\n/* ─── Signal Badge ───────────────────────────────────────────── */\n.signal-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n.signal-sm { padding: 1px 6px; font-size: 10px; }\n.signal-bullish { background: rgba(34, 197, 94, 0.15); color: #22c55e; }\n.signal-bearish { background: rgba(239, 68, 68, 0.15); color: #ef4444; }\n.signal-mixed { background: rgba(234, 179, 8, 0.15); color: #eab308; }\n.signal-neutral { background: rgba(100, 116, 139, 0.15); color: #94a3b8; }\n\n/* ─── Severity Dot ───────────────────────────────────────────── */\n.sev-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.sev-high { background: #ef4444; box-shadow: 0 0 4px #ef4444; }\n.sev-med { background: #eab308; }\n.sev-low { background: #64748b; }\n\n/* ─── Alerts ─────────────────────────────────────────────────── */\n.alerts-section {\n  margin-bottom: 14px;\n}\n.alerts-section h3 {\n  font-size: 13px;\n  font-weight: 600;\n  margin: 0 0 6px 0;\n  color: var(--text);\n}\n.alerts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.alert-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: var(--card);\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  border-left: 3px solid transparent;\n  transition: background 0.15s;\n}\n.alert-item:hover { background: var(--border); }\n.alert-high { border-left-color: #ef4444; }\n.alert-medium { border-left-color: #eab308; }\n.alert-low { border-left-color: #64748b; }\n\n.alert-sym {\n  font-weight: 700;\n  color: var(--accent);\n  min-width: 45px;\n}\n.alert-msg {\n  color: var(--text);\n  flex: 1;\n}\n\n/* ─── Score Chart ─────────────────────────────────────────────── */\n.score-chart-section {\n  margin-bottom: 14px;\n}\n.score-chart-section h3 {\n  font-size: 13px;\n  font-weight: 600;\n  margin: 0 0 6px 0;\n}\n\n/* ─── Holdings Grid ──────────────────────────────────────────── */\n.holdings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 10px;\n}\n\n.holding-card {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 12px;\n  cursor: pointer;\n  transition: border-color 0.15s, transform 0.1s;\n}\n.holding-card:hover {\n  border-color: var(--accent);\n  transform: translateY(-1px);\n}\n.holding-error { opacity: 0.5; cursor: default; }\n\n.hcard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n.hcard-symbol {\n  font-weight: 700;\n  font-size: 15px;\n  color: var(--text);\n}\n.hcard-price {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text);\n  margin-bottom: 4px;\n}\n.hcard-trend {\n  margin-bottom: 8px;\n}\n.hcard-trend-label {\n  font-size: 11px;\n  font-weight: 600;\n}\n.hcard-error {\n  font-size: 11px;\n  color: var(--text-dim);\n}\n\n/* ─── S/R Bar (Mini visual) ──────────────────────────────────── */\n.sr-bar-wrap {\n  margin: 8px 0;\n}\n.sr-bar {\n  position: relative;\n  height: 6px;\n  background: var(--border);\n  border-radius: 3px;\n  margin-bottom: 4px;\n}\n.sr-level {\n  position: absolute;\n  top: -3px;\n  transform: translateX(-50%);\n}\n.sr-level-line {\n  display: block;\n  width: 2px;\n  height: 12px;\n  border-radius: 1px;\n}\n.sr-level.support .sr-level-line { background: #22c55e; }\n.sr-level.resistance .sr-level-line { background: #ef4444; }\n\n.sr-current {\n  position: absolute;\n  top: -4px;\n  transform: translateX(-50%);\n}\n.sr-current-dot {\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--accent);\n  border: 2px solid var(--bg);\n  box-shadow: 0 0 4px var(--accent);\n}\n\n.sr-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 10px;\n  color: var(--text-dim);\n}\n.sr-current-label {\n  font-weight: 700;\n  color: var(--accent);\n}\n\n/* ─── Holding Card Stats ─────────────────────────────────────── */\n.hcard-stats {\n  display: flex;\n  gap: 8px;\n  margin-top: 6px;\n}\n.hcard-stat {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.hcard-stat-label {\n  font-size: 9px;\n  color: var(--text-dim);\n  text-transform: uppercase;\n}\n.hcard-stat-value {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.hcard-breakout {\n  margin-top: 6px;\n  padding: 3px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n.hcard-breakout.bullish { background: rgba(34, 197, 94, 0.15); color: #22c55e; }\n.hcard-breakout.bearish { background: rgba(239, 68, 68, 0.15); color: #ef4444; }\n\n.hcard-patterns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n.hcard-pattern {\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  background: var(--border);\n  color: var(--text);\n}\n.hcard-pattern.bullish { color: #22c55e; }\n.hcard-pattern.bearish { color: #ef4444; }\n\n.hcard-footer {\n  margin-top: 8px;\n  font-size: 10px;\n  color: var(--text-dim);\n  text-align: center;\n}\n\n/* ─── Detail Modal ───────────────────────────────────────────── */\n.analysis-modal {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  width: 90%;\n  max-width: 650px;\n  max-height: 85vh;\n  overflow-y: auto;\n  padding: 20px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.5);\n}\n\n.amodal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.amodal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.amodal-close {\n  background: none;\n  border: none;\n  color: var(--text-dim);\n  font-size: 24px;\n  cursor: pointer;\n}\n.amodal-close:hover { color: var(--text); }\n\n.amodal-section {\n  margin-bottom: 18px;\n  padding: 12px;\n  background: var(--card);\n  border-radius: 8px;\n  border: 1px solid var(--border);\n}\n.amodal-section h3 {\n  font-size: 13px;\n  font-weight: 700;\n  margin: 0 0 10px 0;\n  color: var(--text);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.amodal-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 8px;\n  margin-bottom: 8px;\n}\n.amodal-stat {\n  display: flex;\n  flex-direction: column;\n}\n.amodal-label {\n  font-size: 10px;\n  color: var(--text-dim);\n  text-transform: uppercase;\n}\n.amodal-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.amodal-ma-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n.ma-pill {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n}\n.ma-above { background: rgba(34, 197, 94, 0.12); color: #22c55e; }\n.ma-below { background: rgba(239, 68, 68, 0.12); color: #ef4444; }\n\n.amodal-signals {\n  margin-top: 8px;\n}\n.amodal-signal-item {\n  font-size: 12px;\n  padding: 4px 8px;\n  margin-bottom: 4px;\n  background: rgba(59, 130, 246, 0.1);\n  border-left: 3px solid var(--accent);\n  border-radius: 0 4px 4px 0;\n  color: var(--text);\n}\n\n/* ─── S/R Detail Table ───────────────────────────────────────── */\n.sr-table {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 10px;\n}\n.sr-col h4 {\n  font-size: 12px;\n  margin: 0 0 6px 0;\n  font-weight: 600;\n}\n.sr-row {\n  display: flex;\n  flex-direction: column;\n  padding: 4px 0;\n  border-bottom: 1px solid var(--border);\n}\n.sr-price {\n  font-weight: 700;\n  font-size: 13px;\n}\n.sr-meta {\n  font-size: 10px;\n  color: var(--text-dim);\n}\n.sr-dist {\n  font-size: 10px;\n  color: var(--text-dim);\n}\n\n/* ─── Breakout Banner ────────────────────────────────────────── */\n.breakout-banner {\n  padding: 10px;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n}\n.breakout-banner.bullish { background: rgba(34, 197, 94, 0.1); border: 1px solid rgba(34, 197, 94, 0.3); color: #22c55e; }\n.breakout-banner.bearish { background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); color: #ef4444; }\n.breakout-dir { font-weight: 700; font-size: 14px; }\n\n/* ─── Pattern Cards ──────────────────────────────────────────── */\n.pattern-card {\n  padding: 8px 10px;\n  border-radius: 6px;\n  margin-bottom: 6px;\n  border-left: 3px solid;\n}\n.pattern-bullish { background: rgba(34, 197, 94, 0.06); border-left-color: #22c55e; }\n.pattern-bearish { background: rgba(239, 68, 68, 0.06); border-left-color: #ef4444; }\n.pattern-name { font-weight: 700; font-size: 13px; color: var(--text); }\n.pattern-desc { font-size: 11px; color: var(--text-dim); margin-top: 2px; }\n.pattern-target { font-size: 11px; font-weight: 600; margin-top: 2px; color: var(--accent); }\n\n/* ─── Candlestick List ───────────────────────────────────────── */\n.candle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.candle-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  border-left: 3px solid transparent;\n}\n.candle-bull { border-left-color: #22c55e; background: rgba(34, 197, 94, 0.04); }\n.candle-bear { border-left-color: #ef4444; background: rgba(239, 68, 68, 0.04); }\n.candle-neutral { border-left-color: #64748b; }\n.candle-date { color: var(--text-dim); min-width: 75px; font-size: 11px; }\n.candle-name { flex: 1; font-weight: 600; color: var(--text); }\n.candle-signal { font-size: 10px; text-transform: uppercase; font-weight: 600; }\n.candle-signal.bullish { color: #22c55e; }\n.candle-signal.bearish { color: #ef4444; }\n.candle-signal.neutral { color: #64748b; }\n.candle-str { font-size: 10px; color: var(--text-dim); }\n\n/* ─── Color Helpers ──────────────────────────────────────────── */\n.green { color: #22c55e !important; }\n.red { color: #ef4444 !important; }\n\n/* ─── Modal Overlay (reuse from Portfolio) ────────────────────── */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n/* ─── Mobile ─────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .analysis-panel { padding: 8px; }\n  .holdings-grid { grid-template-columns: 1fr; }\n  .analysis-modal { width: 95%; padding: 14px; }\n  .amodal-grid { grid-template-columns: repeat(2, 1fr); }\n  .sr-table { grid-template-columns: 1fr; }\n  .amodal-ma-row { flex-direction: column; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
